export default {
  MEDICINE: [
    'Addiction Medicine',
    'Allergy / Immunology',
    'Anesthesiology',
    'Cardiology',
    'Dermatology',
    'Diagnostic Radiology',
    'Emergency Medicine',
    'Endocrinology (Diabetes and Metabolism)',
    'Family Medicine',
    'Gastroenterology',
    'Geriatric Medicine',
    'Gynecologic Oncology',
    'Hematology',
    'Hospice and Palliative',
    'Infectious Disease',
    'Internal Medicine',
    'Interventional Cardiology',
    'Maternal and Fetal Medicine',
    'Nephrology',
    'Neurology',
    'Obstetrics and Gynecology',
    'Oncology',
    'Opthalmology',
    'Otalaryngology (Ear, Nose, Throat)',
    'Pain Management',
    'Pathology',
    'Physical Medicine and Rehabilitation',
    'Podiatry',
    'Psychiatry',
    'Pulmonology',
    'Radiation Oncology',
    'Radiology',
    'Reproductive Endocrinology',
    'Rheumatology',
    'Sleep Medicine',
    'Sports Medicine',
    'Urology',
  ],
  PEDIATRICS: [
    'Pediatric General',
    'Pediatric Allergy / Immunology',
    'Pediatric Cardiology',
    'Pediatric Dermatology',
    'Pediatric Endocrinology',
    'Pediatric Gastroenterology',
    'Pediatric Orthopedic Surgery',
    'Pediatric Otalaryngology (ENT)',
    'Pediatric Surgery',
  ],
  SURGERY: [
    'Cardiothoracic Surgery',
    'Colon and Rectal Surgery',
    'Cosmetic Surgery',
    'General Surgery',
    'Hand Surgery',
    'Neurological Surgery',
    'Oral and Maxillofacial Surgery',
    'Orthopedic Surgery',
    'Plastic and Reconstructive Surgery',
    'Spine Surgery',
    'Vascular Surgery',
  ],
};
